var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPencil01A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40.8 40.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    rx: 8,
    ry: 8,
    fill: "#5f1e5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.9454,27.8372l-3.31-3.31-.992,4.302,4.302-.992Zm12.957-12.309l-3.958-3.958-11.825,11.825,3.958,3.958,11.825-11.825Zm-3.151-4.766l3.959,3.959,1.604-1.605c.176-.175.264-.407.264-.638,0-.232-.088-.464-.264-.639l-2.681-2.681c-.175-.176-.407-.264-.639-.264-.231,0-.463.088-.638.264l-1.605,1.604Zm3.69-2.412l2.681,2.681c.399.399.598.923.598,1.447,0,.523-.199,1.047-.598,1.446l-14.641,14.641c-.087.087-.196.141-.309.16l-6.16,1.42c-.307.072-.614-.119-.685-.426-.021-.091-.019-.183.002-.268l1.426-6.185c.025-.108.08-.201.152-.274v-.001l14.641-14.641c.399-.399.923-.598,1.446-.598.524,0,1.048.199,1.447.598",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.1963,33.0476c-.315,0-.571-.256-.571-.571,0-.316.256-.571.571-.571h17.018c.316,0,.571.255.571.571,0,.315-.255.571-.571.571H7.1963Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPencil01A);
export default __webpack_public_path__ + "static/media/ico-pencil-01a.771753d1daf1ad1d562c206ea61ca061.svg";
export { ForwardRef as ReactComponent };